import { compose } from "recompose";
import React, { Component } from "react";
import { withIsServer } from "web/core/branchServerClient";

const withModalRoutes = () =>
  compose(withIsServer(), (BaseComponent) => {
    return class WithModalRoutes extends Component {
      constructor(props) {
        super();

        this.state = {
          previousLocation: null,
          previousPath: null,
          isModal: false,
        };
      }

      componentDidMount() {
        if (this.props.location.state?.modal) {
          this.props.history.replace({
            ...this.props.location,
            state: {
              ...this.props.location.state,
              modal: undefined,
            },
          });
        }
      }

      UNSAFE_componentWillReceiveProps(nextProps) {
        if (
          nextProps.location.key !== this.props.location.key &&
          nextProps.location.pathname !== this.props.location.pathname &&
          nextProps.location.state?.modal
        ) {
          if (!this.state.isModal) {
            this.setState({
              previousLocation: this.props.location,
              previousPath: this.props.location.pathname,
              isModal: true,
            });
          }
        } else if (this.state.isModal) {
          this.setState({ isModal: false });
        }
      }

      render() {
        const isModal = Boolean(
          !this.props.isServer &&
            this.state.previousLocation &&
            this.props.location.state?.modal
        );

        const modalAppearance =
          typeof this.props.location?.state?.modal === "string"
            ? this.props.location?.state?.modal
            : "default";

        return (
          <BaseComponent
            {...this.props}
            isModal={isModal}
            modalAppearance={modalAppearance}
            previousLocation={this.state.previousLocation}
            previousPath={this.state.previousPath}
          />
        );
      }
    };
  });

export default withModalRoutes;
